<template>
	<div class="detail-bar flex-center">
		<div class="flex-grow flex">
			<div v-for="(item, i) in list" :key="i" class="item flex-grow">
				<p>{{item.name}}</p>
				<div class="ellipsis" :style="{'color': item.color ? `var(--color-${item.color})` : ''}">{{item.value}}</div>
			</div>
		</div>
		<c-progress v-if="rate !== false" class="progress" :rate="rate" :color="rateColor" type="circle" size="0.88" line-size="0.08" font-size="0.24">
			<template #text="{rate}">
				<span v-if="rate == 100" style="font-size: .5rem;" :style="{'color': `var(--color-${rateColor})`}"><i class="c-icon-check"></i></span>
				<span v-else :style="{'color': rate > 100 ? '#f00' : ''}">{{rate.toFixed(0)}}%</span>
			</template>
		</c-progress>
	</div>
</template>

<script>
	export default {
		name: 'detailBar',
		
		props: {
			list: Array,
			rate: {
				type: [String, Number, Array, Boolean],
				default: false
			},
			rateColor: {
				type: String,
				default: 'main'
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.detail-bar {
		height: 1.2rem;

		.item {
			padding: 0 .1rem;
			
			p {
				font-size: .24rem;
				text-align: center;
				color: #666;
			}

			div {
				margin-top: .1rem;
				font-size: .26rem;
				font-weight: 500;
				text-align: center;
				color: #000;
			}	
		}

		.progress {
			margin: 0 .24rem;
		}
	}
</style>
